import ContainerHideNavScroll from '../../../Componant/PageLayout/HideNavScroll/HideNavScroll'

const HideNavScrollContainer = () => {
  return (
    <div className='page-body'>
      <ContainerHideNavScroll />
    </div>
  )
}

export default HideNavScrollContainer